module.exports = __webpack_public_path__ + "img/baobaoshu.04da9203.webp";